window.addEventListener("load", function () {
    var lazyLoadInstance = new LazyLoad({});
    AOS.init({
        once: true,
        disable: 'mobile'
    });
    window.addEventListener('scroll', function (e) {
        AOS.init({once: true, disable: 'mobile'});
    });

    const appHeight = () => {
        const doc = document.documentElement
        doc.style.setProperty('--app-height', window.innerHeight + 'px')
    }
    window.addEventListener('resize', appHeight)
    appHeight();

    //hover Menu
    const hover = document.querySelector('.hover-shop');
    if (hover != null) {
        hover.onmouseover = function () {
            document.querySelector('.modal-shop').classList.add('active');
            document.querySelector('.hover-shop').classList.add('active');
        };
        hover.onmouseleave = function () {
            document.querySelector('.modal-shop').classList.remove('active');
            document.querySelector('.hover-shop').classList.remove('active');
        }
        const drop = document.querySelector('.modal-shop');
        drop.onmouseover = function () {
            document.querySelector('.modal-shop').classList.add('active');
            document.querySelector('.hover-shop').classList.add('active');
        };
        drop.onmouseleave = function () {
            document.querySelector('.modal-shop').classList.remove('active');
            document.querySelector('.hover-shop').classList.remove('active');
        }
    }
    //hover Menu End

    //hover Menu Collection
    const hoverCollection = document.querySelector('.hover-collection');
    if (hoverCollection != null) {
        hoverCollection.onmouseover = function () {
            document.querySelector('.modal-collection').classList.add('active');
            document.querySelector('.hover-collection').classList.add('active');
        };
        hoverCollection.onmouseleave = function () {
            document.querySelector('.modal-collection').classList.remove('active');
            document.querySelector('.hover-collection').classList.remove('active');
        }
        const dropCollection = document.querySelector('.modal-collection');
        dropCollection.onmouseover = function () {
            document.querySelector('.modal-collection').classList.add('active');
            document.querySelector('.hover-collection').classList.add('active');
        };
        dropCollection.onmouseleave = function () {
            document.querySelector('.modal-collection').classList.remove('active');
            document.querySelector('.hover-collection').classList.remove('active');
        }
    }
    //hover Menu End

    if (document.querySelector('.hover-shop-xs') !== null) {
        document.querySelector('.hover-shop-xs').addEventListener('click', ({currentTarget}) => {
            event.preventDefault();
            document.querySelector('.modal-shop').classList.add('active-xs');
        });
    }
    if (document.querySelector('.hover-collection-xs') !== null) {
        document.querySelector('.hover-collection-xs').addEventListener('click', ({currentTarget}) => {
            event.preventDefault();
            document.querySelector('.modal-collection').classList.add('active-xs');
        });
    }
    const closeModalHeader = document.querySelectorAll(".header-drop-back");
    closeModalHeader.forEach((item) => {
        item.addEventListener('click', ({currentTarget}) => {
            document.querySelectorAll(".header-drop").forEach((item) => {
                item.classList.remove('active-xs');
            });
        })
    });

    if (document.querySelector('.header-burger') !== null) {
        document.querySelector('.header-burger').addEventListener('click', ({currentTarget}) => {
            event.preventDefault();
            document.querySelector('body').classList.add('no-scroll');
            document.querySelector('.header__right').classList.add('active');
            document.querySelector('.header-overflow').classList.add('active');
        });
    }
    const closeTops = document.querySelectorAll(".header-xs-top__close");
    closeTops.forEach((item) => {
        item.addEventListener('click', ({currentTarget}) => {
            event.preventDefault();
            document.querySelector('body').classList.remove('no-scroll');
            document.querySelector('.header-drop').classList.remove('active-xs');
            document.querySelector('.header__right').classList.remove('active');
            document.querySelector('.header-overflow').classList.remove('active');
        })
    });
    if (document.querySelector('.header-overflow') !== null) {
        document.querySelector('.header-overflow').addEventListener('click', ({currentTarget}) => {
            event.preventDefault();
            document.querySelector('body').classList.remove('no-scroll');
            document.querySelector('.header-drop').classList.remove('active-xs');
            document.querySelector('.header__right').classList.remove('active');
            document.querySelector('.header-overflow').classList.remove('active');
        });
    }

    new Swiper(".section-product__slider", {
        slidesPerView: 1,
        spaceBetween: 24,
        simulateTouch: false,
        preloadImages: false,
        lazyLoading: true,
        watchSlidesVisibility:true,
        lazy: true,
        pagination: {
            el: '.swiper__pagination',
            clickable: true,
        },
        navigation: {
            prevEl: ".swiper__prev",
            nextEl: ".swiper__next"
        },
        breakpoints: {
            500: {slidesPerView: 2, spaceBetween: 18},
            1100: {slidesPerView: 3, spaceBetween: 24},
        }
    });
    new Swiper(".collection-pr-v2__slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        simulateTouch: false,
        preloadImages: false,
        lazyLoading: true,
        watchSlidesVisibility:true,
        lazy: true,
        pagination: {
            el: '.swiper__pagination',
            clickable: true,
        },
        navigation: {
            prevEl: ".swiper__prev",
            nextEl: ".swiper__next"
        },
        breakpoints: {
            500: {slidesPerView: 2, spaceBetween: 18},
            1100: {slidesPerView: 3, spaceBetween: 24},
        },
        on: {
            afterInit: function(swiper) {
                if (swiper.params.slidesPerView >= swiper.slides.length) {
                    document.querySelectorAll('.collection-pr-arrow').forEach((item) => {
                        item.style.display = 'none';
                    })
                }
            }
        }
    });
    const galleryThumbs = new Swiper(".product-thumbs", {
        direction: 'vertical',
        spaceBetween: 10,
        slidesPerView: 7.5,
        watchSlidesVisibility: true,
        watchSlidesProgress: true
    });
    new Swiper(".product-top", {
        slidesPerView: 1,
        resistance: true,
        resistanceRatio: 0,
        spaceBetween: 5,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: ".product-slider__next",
            prevEl: ".product-slider__prev"
        },
        thumbs: {
            swiper: galleryThumbs
        }
    });

    let prevScrollpos = window.pageYOffset;
    window.onscroll = function () {
        let currentScrollPos = window.pageYOffset;
        if (currentScrollPos > 40) {
            if (prevScrollpos > currentScrollPos) {
                document.querySelector(".header").style.top = "0";
            } else {
                document.querySelector(".header").style.top = "-150px";
            }
        }

        if (currentScrollPos > 20) {
            document.querySelector(".header").classList.add('active');
        }
        if (currentScrollPos < 20) {
            document.querySelector(".header").classList.remove('active');
        }
        prevScrollpos = currentScrollPos;
    }

    if (new URL(window.location.href).searchParams.get("contact_posted")) {
        document.querySelector('body').classList.add('overflow-hidden');
        document.querySelector('.overflow').classList.add('active');
        document.querySelector('.modal-thank').classList.add('active');
    }
    if (new URL(window.location.href).searchParams.get("customer_posted")) {
        document.querySelector('body').classList.add('overflow-hidden');
        document.querySelector('.overflow-subscribe').classList.add('active');
        document.querySelector('.modal-thank-subscribe').classList.add('active');
    }

    const openJewelry = document.querySelectorAll(".jewelry-list");
    openJewelry.forEach((item) => {
        item.addEventListener('click', ({currentTarget}) => {
            document.querySelector('body').classList.add('overflow-hidden');
            document.querySelector('.overflow').classList.add('active');
            document.querySelector('.modal-jewerly').classList.add('active');
        });
    });
    const openFeedback = document.querySelectorAll(".open-feedback");
    openFeedback.forEach((item) => {
        item.addEventListener('click', ({currentTarget}) => {
            const name = currentTarget.closest('.product-item').querySelector('.product-item__name').innerHTML

            document.querySelector('.product-name-input').value = name;
            document.querySelector('body').classList.add('overflow-hidden');
            document.querySelector('.overflow').classList.add('active');
            document.querySelector('.modal-feedback').classList.add('active');
        });
    });
    const closeModal = document.querySelectorAll(".modal-close");
    closeModal.forEach((item) => {
        item.addEventListener('click', ({currentTarget}) => {
            closesModal();
        })
    });
    if (document.querySelector('.overflow') !== null) {
        document.querySelector('.overflow').addEventListener('click', ({currentTarget}) => {
            closesModal();
        });
    }

    const inputError = document.querySelectorAll(".field-error input");
    inputError.forEach(function (input) {
        input.addEventListener('input', ({currentTarget}) => {
            if (document.querySelector('#ContactForm-name-jewerly').value.length !== 0
                && document.querySelector('#ContactForm-phone-jewerly').value.length !== 0
                && document.querySelector('#ContactForm-email-jewerly').value.length !== 0) {
                document.querySelector('.contact__button button.jewerly').disabled = false;
            } else {
                document.querySelector('.contact__button button.jewerly').disabled = true;
            }

            if (document.querySelector('#ContactForm-name').value.length !== 0
                && document.querySelector('#ContactForm-phone').value.length !== 0
                && document.querySelector('#ContactForm-email').value.length !== 0 ) {
                document.querySelector('.contact__button button.feedback').disabled = false;
            } else {
                document.querySelector('.contact__button button.feedback').disabled = true;
            }

        });
    });

    checkSubscriber('#ContactBanner')
    checkSubscriber('#ContactSubscriber')
    checkSubscriber('#ContactFooter')

    const feedbackBtn = document.querySelectorAll(".contact__button .feedback");
    feedbackBtn.forEach(function (feedback) {
        feedback.addEventListener('click', ({currentTarget}) => {
            checkForm();
            if (validateEmail(document.querySelector('input#ContactForm-email').value)
                && validatePhone(document.querySelector('input#ContactForm-phone').value)
            ) {
            } else {
                event.preventDefault();
            }
        })
    });

    const jewerlyBtn = document.querySelectorAll(".contact__button .jewerly");
    jewerlyBtn.forEach(function (feedback) {
        feedback.addEventListener('click', ({currentTarget}) => {
            checkForm();
            if (validateEmail(document.querySelector('input#ContactForm-email-jewerly').value)
                && validatePhone(document.querySelector('input#ContactForm-phone-jewerly').value)
            ) {
            } else {
                event.preventDefault();
            }
        })
    });

    if (document.querySelector('.category-in-top-params__main') !== null) {
        document.querySelector('.category-in-top-params__main').addEventListener('click', ({currentTarget}) => {
            const content = document.querySelector('.params-modal');
            if (currentTarget.classList.contains('active')) {
                document.querySelector('.category-overflow').classList.remove('active');
                currentTarget.classList.remove('active');
                content.classList.remove('active');
                content.style.maxHeight = 0;
            } else {
                document.querySelector('.category-overflow').classList.add('active');
                currentTarget.classList.add('active');
                content.classList.add('active');
                content.style.maxHeight = content.scrollHeight + 'px';

                document.querySelector('.sort-select__main').classList.remove('active');
                document.querySelector('.sort-select__info').style.maxHeight = 0;
                document.querySelector('.sort-select__info').style.maxHeight = 0;
            }
        })

        document.querySelector('.params-modal__close').addEventListener('click', ({currentTarget}) => {
            document.querySelector('.category-overflow').classList.remove('active');
            if (document.querySelector('.category-in-top-params__main') !== null)
                document.querySelector('.category-in-top-params__main').classList.remove('active');
            document.querySelector('.params-modal').classList.remove('active');
            document.querySelector('.params-modal').style.maxHeight = 0;
        });
        document.querySelector('.category-overflow').addEventListener('click', ({currentTarget}) => {
            document.querySelector('.category-overflow').classList.remove('active');
            if (document.querySelector('.category-in-top-params__main') !== null)
                document.querySelector('.category-in-top-params__main').classList.remove('active');
            document.querySelector('.params-modal').classList.remove('active');
            document.querySelector('.params-modal').style.maxHeight = 0;
        });
    }

    //custom Select Sort
    if (document.querySelector('.sort-select__main') !== null) {
        document.querySelector('.sort-select__main').addEventListener('click', ({currentTarget}) => {
            const content = document.querySelector('.sort-select__info');
            if (currentTarget.classList.contains('active')) {
                document.querySelector('.category-overflow').classList.remove('active');
                currentTarget.classList.remove('active');
                content.classList.remove('active');
                content.style.maxHeight = 0;
            } else {
                document.querySelector('.category-overflow').classList.add('active');
                currentTarget.classList.add('active');
                content.classList.add('active');
                content.style.maxHeight = content.scrollHeight + 'px';

                if(document.querySelector('.category-in-top-params__main') !== null)
                    document.querySelector('.category-in-top-params__main').classList.remove('active');
                document.querySelector('.params-modal').classList.remove('active');
                document.querySelector('.params-modal').style.maxHeight = 0;
            }
        })

        document.querySelector('.sort-select-xs__close').addEventListener('click', ({currentTarget}) => {
            document.querySelector('.category-overflow').classList.remove('active');
            document.querySelector('.sort-select__main').classList.remove('active');
            document.querySelector('.sort-select__info').classList.remove('active');
            document.querySelector('.sort-select__info').style.maxHeight = 0;
        });
        document.querySelector('.category-overflow').addEventListener('click', ({currentTarget}) => {
            document.querySelector('.category-overflow').classList.remove('active');
            document.querySelector('.sort-select__main').classList.remove('active');
            document.querySelector('.sort-select__info').classList.remove('active');
            document.querySelector('.sort-select__info').style.maxHeight = 0;
        });

        const select = document.querySelectorAll(".sort-select__item");
        select.forEach((item) => {
            item.addEventListener('click', ({currentTarget}) => {
                document.querySelectorAll(".sort-select__item").forEach((item) => {
                    item.classList.remove('active');
                });
                currentTarget.classList.add('active');

                const content = document.querySelector('.sort-select__info');

                document.querySelector('.sort-select__main').classList.remove('active');
                document.querySelector('.category-overflow').classList.remove('active');
                content.classList.remove('active');
                content.style.maxHeight = 0;
                document.querySelector('#SortBy-mobile option[value=price-ascending]').selected = true;
            });
        });
    }
    //custom Select Sort End
    const form = document.querySelector('#FacetFiltersFormMobile');
    const select = document.querySelectorAll(".sort-select__item");
    select.forEach((item, itemIndex) => {
        item.addEventListener('click', ({currentTarget}) => {
            const event = new Event('change');
            const eventSubmit = new Event('input');
            const selectSort = document.querySelector('#SortBy-mobile');

            selectSort.selectedIndex = itemIndex;
            selectSort.dispatchEvent(event);
            form.dispatchEvent(eventSubmit);

            const content = document.querySelector('.sort-select__info');

            document.querySelector('.sort-select__main').classList.remove('active');
            content.classList.remove('active');
            content.style.maxHeight = 0;
        });
    });

    const faqProducts = document.querySelectorAll('.product-faq__name');
    faqProducts.forEach((faqProduct) => {
        faqProduct.addEventListener('click', ({currentTarget}) => {
            const mainFaqSeo = currentTarget.parentNode;
            const contentFaqSeo = currentTarget.parentNode.querySelector('.product-faq__content');

            if (mainFaqSeo.classList.contains('active')) {
                mainFaqSeo.classList.remove('active');
                contentFaqSeo.style.maxHeight = 0;
            } else {
                mainFaqSeo.classList.add('active');
                contentFaqSeo.style.maxHeight = contentFaqSeo.scrollHeight + 'px';
            }
        });
    });

    const faqMain = document.querySelectorAll('.section-faq__name');
    faqMain.forEach((faq) => {
        faq.addEventListener('click', ({currentTarget}) => {
            const mainFaq = currentTarget.parentNode;
            const contentFaq = currentTarget.parentNode.querySelector('.section-faq__info');

            if (mainFaq.classList.contains('active')) {
                mainFaq.classList.remove('active');
                contentFaq.style.maxHeight = 0;
            } else {
                mainFaq.classList.add('active');
                contentFaq.style.maxHeight = contentFaq.scrollHeight + 'px';
            }
        });
    });

    const customerOrder = document.querySelectorAll('.order-product-more');
    customerOrder.forEach((order) => {
        order.addEventListener('click', ({currentTarget}) => {
            const mainFaq = currentTarget.parentNode;
            const contentFaq = currentTarget.parentNode.querySelector('.orders-table-td-product');

            if (mainFaq.classList.contains('active')) {
                mainFaq.classList.remove('active');
                contentFaq.style.maxHeight = 0;
            } else {
                mainFaq.classList.add('active');
                contentFaq.style.maxHeight = contentFaq.scrollHeight + 'px';
            }
        });
    });

    if (document.querySelector('input.input-Yes') !== null) {
        document.querySelector('.engraving-input input').addEventListener('input', ({currentTarget}) => {
            document.querySelector('input.input-Yes').value = currentTarget.value;
        });
        changeInput();
    }

    if (document.querySelector('.header-search') !== null) {
        document.querySelector('.header-search').addEventListener('click', ({currentTarget}) => {
            const content = document.querySelector('.modal-search')
            if (currentTarget.classList.contains('active')) {
                currentTarget.classList.remove('active');
                content.classList.remove('active');
                document.querySelector('.modal-search-overflow').classList.remove('active');
                document.querySelector('body').classList.remove('no-scroll');
            } else {
                currentTarget.classList.add('active');
                content.classList.add('active');
                document.querySelector('.modal-search-overflow').classList.add('active');
                document.querySelector('body').classList.add('no-scroll');
            }
        })
    }

    const shopPassIcon = document.querySelectorAll('.show-pass-icon');
    shopPassIcon.forEach((item) => {
        item.addEventListener('click', ({currentTarget}) => {
            const content = currentTarget.closest('.pass-input');

            if (content.classList.contains('show')) {
                content.querySelector('input').setAttribute('type', 'text');
                content.classList.remove('show');
            }else {
                content.querySelector('input').setAttribute('type', 'password');
                content.classList.add('show');
            }
        });
    });
    //FAV

    if (document.querySelector('form#customer_login') != null) {
        document.querySelector('form#customer_login').addEventListener('submit', ({currentTarget}) => {
            validatePassword();
        });
    }
    checkFavorite();
    checkFavActive();
    countWishList();
});

function validatePassword()
{
    const password = document.querySelector("input#password");
    const confirm_password = document.querySelector("input#password_confirmation");
    if(password.value != confirm_password.value) {
        event.preventDefault();
        document.querySelector('.reset-password-error').innerHTML = "Passwords Don't Match";
    } else if(password.value == '' || password.value == undefined || password.value == null) {
        event.preventDefault();
        document.querySelector('.reset-password-error').innerHTML = "Passwords must not be empty";
    } else if(password.value.length < 5 ) {
        event.preventDefault();
        document.querySelector('.reset-password-error').innerHTML = "Minimum 5 characters";
    } else {
        document.querySelector('.reset-password-error').style.display = 'none';
    }
}

function removeCartItem(currentTarget) {
    const name = currentTarget.closest('.cart-item').getAttribute('data-remove');
    document.querySelector('#MainCartItem-'+name).remove();
}

function checkFavorite() {
    const addFav = document.querySelectorAll('.add-fav');
    addFav.forEach((item) => {
        const id = item.querySelector('.product-item-fav').getAttribute('data-id');
        item.setAttribute('data-id', id);

        item.addEventListener('click', ({currentTarget}) => {
            event.preventDefault();
            const id = event.currentTarget.getAttribute('data-id');
            const content = currentTarget.querySelector('.product-fav-ajax').innerHTML;
            const entry = {
                id,
                content
            };
            const favProducts = localStorage.getItem("favProducts");

            if (currentTarget.classList.contains('add_f')) {
                currentTarget.classList.add('no_f');
                currentTarget.classList.remove('add_f');
            } else {
                currentTarget.classList.add('add_f');
                currentTarget.classList.remove('no_f');
                const wishlistCount = document.querySelectorAll('.header-wishlist-count');
                wishlistCount.forEach((item) => {
                    item.classList.remove('none');
                });
            }


            if (!favProducts) {
                localStorage.setItem('favProducts', JSON.stringify([entry]));
            } else {
                const array = JSON.parse(favProducts);
                if (array.some(({id}) => entry.id === id)) {
                    const newProducts = array.filter(({id}) => entry.id !== id)
                    localStorage.setItem('favProducts', JSON.stringify(newProducts));
                } else {
                    array.push({
                        "id": entry['id'],
                        "content": entry['content']
                    });
                    localStorage.setItem('favProducts', JSON.stringify(array));
                }
            }
            countWishList();
        })
    });

}

function checkFavActive() {
    const addFav = document.querySelectorAll('.add-fav');
    addFav.forEach(function (fav) {
        fav.classList.add('no_f');
        fav.classList.remove('add_f');

        if (JSON.parse(localStorage.getItem("favProducts")) !== null) {
            JSON.parse(localStorage.getItem("favProducts")).forEach((item) => {
                if (item['id'] === fav.getAttribute('data-id')) {
                    fav.classList.remove('no_f');
                    fav.classList.add('add_f');
                }
            });
        }
    })
}

function removeFavFunc(id, currentTarget) {
    const favProducts = localStorage.getItem("favProducts")
    const array = JSON.parse(favProducts);
    const entry = {id}

    const newProducts = array.filter(({id}) => entry.id !== id)
    localStorage.setItem('favProducts', JSON.stringify(newProducts));

    countWishList();
    currentTarget.closest('.product-item').classList.add('remove');
}

function countWishList() {
    if (JSON.parse(localStorage.getItem("favProducts"))) {
        document.querySelectorAll('.header-wishlist-count').forEach(function (item) {
            item.classList.remove('none')
            if (JSON.parse(localStorage.getItem("favProducts")).length === 0) {
                item.classList.add('hidden')
            } else {
                item.classList.remove('hidden')
            }
            item.innerHTML = "<span class='brackets'>(</span>"+JSON.parse(localStorage.getItem("favProducts")).length+"<span class='brackets'>)</span>";
        });
    }
}

function changeInput(item) {
    event.stopPropagation();
    // event.preventDefault();
    if (document.querySelector('input.input-Yes').checked) {
        document.querySelector('.engraving-input').classList.add('active')
    }else {
        document.querySelector('.engraving-input').classList.remove('active')
    }
}

function checkSubscriber(id) {
    if (document.querySelector(id+' .newsletter-form__button') !== null) {
        document.querySelector(id+' .newsletter-form__button').addEventListener('click', ({currentTarget}) => {
            checkForm();

            if (validateEmail(document.querySelector(id +' .field__input').value)) {
            } else {
                event.preventDefault();
            }
        });
    }
}

function closesModal() {
    document.querySelector('body').classList.remove('overflow-hidden');
    if (document.querySelector('.overflow-subscribe') != null)
        document.querySelector('.overflow-subscribe').classList.remove('active');
    document.querySelector('.overflow').classList.remove('active');
    document.querySelectorAll(".modal").forEach((item) => {
        item.classList.remove('active');
    });
    // window.history.pushState(null, null, 'https://' + window.location.hostname);
}

function checkForm() {
    const input = document.querySelectorAll(".field-error");
    input.forEach(function (item) {
        item.querySelector('.error').classList.remove('active');

        if (item.querySelector('input').name === 'contact[email]') {
            if (validateEmail(item.querySelector('input').value)) {
                item.querySelector('.error').classList.remove('active');
            } else {
                item.querySelector('.error').classList.add('active');
            }
        } else if (item.querySelector('input').name === 'contact[Phone number]') {
            if (validatePhone(item.querySelector('input').value)) {
                item.querySelector('.error').classList.remove('active');
            } else {
                item.querySelector('.error').classList.add('active');
            }
        } else if (item.querySelector('input').value === '') {
            item.querySelector('.error').classList.add('active');
        }
    });
}

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

function validatePhone(phone) {
    var re = /^(\+?\d{1,4}[\s-]?)?(\(?\d{3}\)?[\s-]?)?[\d\s-]{7,10}$/;
    return re.test(phone)
}

